/**
 * @fileoverview ColaExterna page component
 * Displays external providers with their assigned tasks in priority order
 */

import React from 'react';
import ColaOperarios from './cola-operarios';

const ColaExterna: React.FC = () => {
  return <ColaOperarios tipoCola="externo" />;
};

export default ColaExterna;









